import r from "./td-longtail-vue-components111.js";
/* empty css                              */
import a from "./td-longtail-vue-components98.js";
var _ = function() {
  var s = this, e = s._self._c, t = s._self._setupProxy;
  return e("span", { staticClass: "price", class: t.classes }, [s.preText ? e("span", { staticClass: "price__pre-text", class: t.preTextClasses, domProps: { innerHTML: s._s(s.preText) } }) : s._e(), e("span", { staticClass: "price__amount", class: t.priceClasses }, [s._v(" " + s._s(s.amount) + " ")]), s.postText ? e("span", { staticClass: "price__post-text", domProps: { innerHTML: s._s(s.postText) } }) : s._e()]);
}, p = [], n = /* @__PURE__ */ a(
  r,
  _,
  p,
  !1,
  null,
  "8fafa2a4"
);
const m = n.exports;
export {
  m as default
};
